"use client";

import { useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FleetShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const [activeSedanIndex, setActiveSedanIndex] = useState(0);
  const [activeSuvIndex, setActiveSuvIndex] = useState(0);
  const sedans = [{
    image: "https://humane-alien.10web.cloud/wp-content/uploads/2026/02/range_rover_autobiography_edition.webp?v=qez6pzohcul",
    caption: "Cars at airports"
  }, {
    image: "https://humane-alien.10web.cloud/wp-content/uploads/2026/02/mercedes_s_class_luxury_sedan.webp?v=xuh8njsuemt",
    caption: "Mercedes-Benz S-Class"
  }, {
    image: "https://humane-alien.10web.cloud/wp-content/uploads/2026/02/luxury_sedan_bmw.webp?v=ageob0rc6b",
    caption: "BMW 7 Series"
  }, {
    image: "https://humane-alien.10web.cloud/wp-content/uploads/2026/02/luxury_sedan_audi_a8.webp?v=l57c61xtneh",
    caption: "Audi A8"
  }, {
    image: "https://humane-alien.10web.cloud/wp-content/uploads/2026/02/audi_a8l_chauffeur_service.webp?v=yzl80rbh4xe",
    caption: "Lexus LS"
  }];
  const suvs = [{
    image: "https://humane-alien.10web.cloud/wp-content/uploads/2026/02/executive_suv_black.webp?v=by6q1h5ndu",
    caption: "Cadillac Escalade"
  }, {
    image: "https://humane-alien.10web.cloud/wp-content/uploads/2026/02/luxury_suv_range_rover.webp?v=arb0n9dt4bh",
    caption: "Range Rover"
  }, {
    image: "https://humane-alien.10web.cloud/wp-content/uploads/2026/02/luxury_sedan_mercedes_s_class.webp?v=yfh0ylcdwxn",
    caption: "Mercedes-Benz GLS"
  }, {
    image: "https://humane-alien.10web.cloud/wp-content/uploads/2026/02/bmw_x7_m60i_luxury_suv.webp?v=nrjc4xv7rr",
    caption: "BMW X7"
  }];
  return <section id="fleet-showcase" ref={ref} className="dark bg-background text-foreground section-padding relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className={`text-center mb-12 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-4 bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent">
            Our Premium Fleet
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Experience luxury transportation with our meticulously maintained
            collection of sedans and SUVs
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {}
          <div data-index={0} className={`transition-all duration-[var(--duration-slow)] delay-100 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <h3 className="text-2xl font-display font-semibold mb-6 text-center">
              Luxury Sedans
            </h3>
            <Carousel opts={{
            loop: true,
            dragFree: true
          }} className="w-full" setApi={api => {
            if (!api) return;
            api.on("select", () => {
              setActiveSedanIndex(api.selectedScrollSnap());
            });
          }}>
              <CarouselContent>
                {sedans.map((sedan, i) => <CarouselItem key={i} data-index={i}>
                    <div className="relative aspect-[4/3] rounded-lg overflow-hidden glass-effect group">
                      <img src={sedan.image} alt={sedan.caption} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] group-hover:scale-105" />
                      <div className={`absolute inset-0 bg-gradient-to-t from-dark-section/90 via-dark-section/40 to-transparent flex items-end p-6 transition-opacity duration-[var(--duration-medium)] ${activeSedanIndex === i ? "opacity-100" : "opacity-0"}`}>
                        <p className="text-xl font-display font-semibold bg-gradient-to-r from-white via-secondary to-white bg-clip-text text-transparent">
                          {sedan.caption}
                        </p>
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              <CarouselPrevious className="left-2 bg-white/10 backdrop-blur-md border-white/20 text-white hover:bg-white/20" />
              <CarouselNext className="right-2 bg-white/10 backdrop-blur-md border-white/20 text-white hover:bg-white/20" />
            </Carousel>
          </div>

          {}
          <div data-index={1} className={`transition-all duration-[var(--duration-slow)] delay-200 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <h3 className="text-2xl font-display font-semibold mb-6 text-center">
              Luxury SUVs
            </h3>
            <Carousel opts={{
            loop: true,
            dragFree: true
          }} className="w-full" setApi={api => {
            if (!api) return;
            api.on("select", () => {
              setActiveSuvIndex(api.selectedScrollSnap());
            });
          }}>
              <CarouselContent>
                {suvs.map((suv, i) => <CarouselItem key={i} data-index={i}>
                    <div className="relative aspect-[4/3] rounded-lg overflow-hidden glass-effect group">
                      <img src={suv.image} alt={suv.caption} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] group-hover:scale-105" />
                      <div className={`absolute inset-0 bg-gradient-to-t from-dark-section/90 via-dark-section/40 to-transparent flex items-end p-6 transition-opacity duration-[var(--duration-medium)] ${activeSuvIndex === i ? "opacity-100" : "opacity-0"}`}>
                        <p className="text-xl font-display font-semibold bg-gradient-to-r from-white via-secondary to-white bg-clip-text text-transparent">
                          {suv.caption}
                        </p>
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              <CarouselPrevious className="left-2 bg-white/10 backdrop-blur-md border-white/20 text-white hover:bg-white/20" />
              <CarouselNext className="right-2 bg-white/10 backdrop-blur-md border-white/20 text-white hover:bg-white/20" />
            </Carousel>
          </div>
        </div>
      </div>
    </section>;
}